<template>
  <div>
    <a
      role="button"
      class="moe-button"
      :href="url"
      :class="[
        theme ? `moe-button--${theme}` : '',
        rounded ? `moe-button--rounded` : '',
        roundedFull ? `moe-button--rounded-full` : '',
      ]"
      :aria-label="label ? label : ariaLabel"
      :aria-describedby="ariaDescribedBy"
      @click="handleClick($event)"
    >
      <span class="moe-button__label">
        <pulse-loader
          :loading="isLoading"
          :color="'#ffffff'"
          :size="'6px'"
        />
        <span
          v-if="labelIconLeft === 'back'"
          class="moe-button__label-icon-left"
        >
          <img
            class="moe-button__icon-image"
            src="/themes/custom/ncea/dist/images/arrow-left-black.svg"
            alt="Back"
          />
        </span>
        <span
          v-if="label && label !== ''"
          :class="['moe-button__label-text', isLoading ? 'moe-button__label-text--loading' : '']"
        >
          {{ label }}
        </span>
        <span
          v-if="labelIcon === 'download'"
          class="moe-button__label-icon"
        >
          <img
            class="moe-button__icon-image"
            src="/themes/custom/ncea/dist/images/icon-download-white.svg"
            alt="Download"
          />
          <img
            class="moe-button__icon-image moe-button__icon-image--hover"
            src="/themes/custom/ncea/dist/images/icon-download-blue.svg"
            alt="Download"
          />
        </span>
      </span>
      <span
        v-if="hint && hint !== ''"
        class="moe-button__hint"
      >
        {{ hint }}
      </span>
      <span
        v-if="icon === 'download'"
        class="moe-button__icon"
      >
        <img
          class="moe-button__icon-image"
          src="/themes/custom/ncea/dist/images/icon-download-white.svg"
          alt="Download"
        />
        <img
          class="moe-button__icon-image moe-button__icon-image--hover"
          src="/themes/custom/ncea/dist/images/icon-download-blue.svg"
          alt="Download"
        />
      </span>
      <span
        v-if="icon === 'chevron-down'"
        class="moe-button__icon moe-button__icon--no-margin"
      >
        <font-awesome-icon icon="chevron-down" />
      </span>
      <span
        v-if="icon === 'close'"
        class="moe-button__icon moe-button__icon--no-margin"
      >
        <img
          class="moe-button__icon-image"
          src="/themes/custom/ncea/dist/images/icon-light-close-white.svg"
          alt="Download"
        />
      </span>
    </a>
    <span
      v-if="footnote && footnote !== ''"
      class="moe-button__footnote"
    >
      {{ footnote }}
    </span>
  </div>
</template>

<script>
import { PulseLoader } from 'vue-spinner/dist/vue-spinner.min';

export default {
  name: 'MoeButton',
  components: {
    PulseLoader,
  },
  props: {
    url: {
      type: String,
      required: false,
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    hint: {
      type: String,
      required: false,
      default: '',
    },
    footnote: {
      type: String,
      required: false,
      default: '',
    },
    icon: {
      type: String,
      required: false,
      default: '',
    },
    labelIcon: {
      type: String,
      required: false,
      default: '',
    },
    labelIconLeft: {
      type: String,
      required: false,
      default: '',
    },
    theme: {
      type: String,
      required: false,
      default: 'default',
    },
    rounded: {
      type: Boolean,
      required: false,
      default: false,
    },
    roundedFull: {
      type: Boolean,
      required: false,
      default: false,
    },
    isLoading: {
      type: [Boolean, Object],
      required: false,
      default: false,
    },
    ariaLabel: {
      type: String,
      required: false,
      default: null,
    },
    ariaDescribedBy: {
      type: String,
      required: false,
      default: null,
    },
    analyticsLabel: {
      type: String,
      required: false,
      default: '',
    },
    eventPreventDefault: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['handle-click'],
  methods: {
    handleClick(e) {
      if (this.eventPreventDefault) e.preventDefault();
      e.currentTarget.blur();
      // eslint-disable-next-line vue/require-explicit-emits
      this.$emit('handle-click');

      if (this.analyticsLabel) {
        // Push file download event and label to Google Tag Manager
        /* global dataLayer */
        if (dataLayer) {
          dataLayer.push({
            event: 'FileDownload',
            GALabel: `${this.analyticsLabel} - ${window.location.pathname}`,
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../scss/partials/moe-button';
</style>
